/* eslint-disable @typescript-eslint/no-unused-vars */
/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-11-17 10:58:18
 * @LastEditors: K
 * @LastEditTime: 2022-09-22 11:19:47
 */
import { createAsyncThunk } from '@reduxjs/toolkit'
import _ from 'lodash'
import { sendAsync } from '../../app/applicationSlice'
import { RootThunkApi } from '../../app/store'
import {
  ReplaceMakeSupplierList,
  addReplaceMakeSupplier,
  ReplaceMakeSupplierParams,
  addReplaceMakeSupplierParams,
  openReplaceMakeSupplier,
  machiningType,
  setReplaceMakeSupplier,
  SupplierPartnerParams,
  SupplierPartnerList,
  ChangeSupplierPartnerParams,
  changeSupplierPartner,
  AddEditSupplierPartnerParams,
  addEditSupplierPartner,
  OrganizationNameParams,
  organizationName,
  addEditType,
  showSupplierPartner,
  isChangeReplaceMakeParams,
  ChangeReplaceMake,
  getPotionPlace,
  getHerbsListFn,
  getGoodsListFn,
  getGoodsListFnParams,
  getHerbsListFnParams,
  getDeleteHerbsListFn,
  getDeleteHerbsListFnParams,
  getAddHerbsListFn,
  getAddHerbsListFnParams,
} from '../../services/replaceMakeSupplier'

//  代煎饮片厂列表
export const getReplaceMakeSupplierList = createAsyncThunk<
  any,
  ReplaceMakeSupplierParams,
  RootThunkApi
>('stand/getReplaceMakeSupplierList', async (params, api) => {
  return sendAsync(ReplaceMakeSupplierList(params), api)
})

//  修改新增代煎饮片厂
export const isAddReplaceMakeSupplier = createAsyncThunk<
  any,
  addReplaceMakeSupplierParams,
  RootThunkApi
>('stand/isAddReplaceMakeSupplier', async (params, api) => {
  return sendAsync(addReplaceMakeSupplier(params), api)
})

// 代煎回显
export const isSetReplaceMakeSupplier = createAsyncThunk<
  any,
  string,
  RootThunkApi
>('stand/setReplaceMakeSupplier', async (id, api) => {
  return sendAsync(setReplaceMakeSupplier(id), api)
})

//   开启/禁用代煎饮片厂
export const isOpenReplaceMakeSupplier = createAsyncThunk<
  any,
  string,
  RootThunkApi
>('stand/isOpenReplaceMakeSupplier', async (id, api) => {
  return sendAsync(openReplaceMakeSupplier(id), api)
})

// 获取加工方式、代煎类型
export const getMachiningType = createAsyncThunk<any, void, RootThunkApi>(
  'stand/getMachiningType',
  async (_, api) => {
    return sendAsync(machiningType(), api)
  }
)

// 合作平台

// 获取代煎饮片厂的合作机构
export const getSupplierPartnerList = createAsyncThunk<
  any,
  SupplierPartnerParams,
  RootThunkApi
>('stand/getSupplierPartnerList', async (params, api) => {
  return sendAsync(SupplierPartnerList(params), api)
})

//  修改合作机构的绑定状态
export const isEditSupplierPartner = createAsyncThunk<
  any,
  ChangeSupplierPartnerParams,
  RootThunkApi
>('stand/isEditSupplierPartner', async (params, api) => {
  return sendAsync(changeSupplierPartner(params), api)
})

// 新增/修改合作机构的模糊查询
export const getOrganizationName = createAsyncThunk<
  any,
  OrganizationNameParams,
  RootThunkApi
>('stand/getOrganizationName', async (params, api) => {
  return sendAsync(organizationName(params), api)
})

// 新增/修改合作机构的代煎类别
export const getAddEditType = createAsyncThunk<
  any,
  { tenantId?: number | string; id?: string | number },
  RootThunkApi
>('stand/getAddEditType', async (params, api) => {
  return sendAsync(addEditType(params), api)
})

// 新增/修改合作机构
export const isAddEditSupplierPartner = createAsyncThunk<
  any,
  AddEditSupplierPartnerParams,
  RootThunkApi
>('stand/isAddEditSupplierPartner', async (params, api) => {
  return sendAsync(addEditSupplierPartner(params), api)
})

// 合作机构回显
export const isShowSupplierPartner = createAsyncThunk<
  any,
  string,
  RootThunkApi
>('stand/isShowSupplierPartner', async (id, api) => {
  return sendAsync(showSupplierPartner(id), api)
})

// 判断是否可删除
export const isChangeReplaceMake = createAsyncThunk<
  void,
  isChangeReplaceMakeParams,
  RootThunkApi<void>
>('tenant/isChangeReplaceMake', async (tenant, api) => {
  return sendAsync(ChangeReplaceMake(tenant), api)
})

// 代煎供应商列表
export const getPotionPlaceAsync = createAsyncThunk<
  any,
  void,
  RootThunkApi<void>
>('tenant/isChangeReplaceMake', async (_, api) => {
  return sendAsync(getPotionPlace(), api)
})
// 代煎饮片厂-商品目录列表
export const getGoodsList = createAsyncThunk<
  any,
  getGoodsListFnParams,
  RootThunkApi<void>
>('tenant/getGoodsList', async (params, api) => {
  return sendAsync(getGoodsListFn(params), api)
})
// 代煎药材目录
export const getHerbsList = createAsyncThunk<
  any,
  getHerbsListFnParams,
  RootThunkApi<void>
>('tenant/getHerbsList', async (params, api) => {
  return sendAsync(getHerbsListFn(params), api)
})
// 代煎药材目录-新增 or 编辑
export const getAddHerbsList = createAsyncThunk<
  any,
  getAddHerbsListFnParams,
  RootThunkApi<void>
>('tenant/getAddHerbsList', async (params, api) => {
  return sendAsync(getAddHerbsListFn(params), api)
})
// 代煎药材目录-删除
export const getDeleteHerbsList = createAsyncThunk<
  any,
  getDeleteHerbsListFnParams,
  RootThunkApi<void>
>('tenant/getDeleteHerbsList', async (params, api) => {
  return sendAsync(getDeleteHerbsListFn(params), api)
})

